<template>
    <window :size="size" :title="size == 'full' ? '' : title" ref="window">
        <editable ref="editable"
            :class="clContainer('container container-xs text-center')" 
            default-state="edit" 
            :show-toggle-button="false"
            @datachange="rating = $event.data">

            <template slot-scope="editable">
                <h2 v-if="size == 'full'">{{ title }}</h2>

                <div v-if="userPicture" :class="clSub('user-picture')">
                    <img :src="userPicture" />
                </div>

                <h3>{{ __('subtitle.?') }}</h3>

                <editable-choose name="rating" :class="clSub('stars-container')" @user-input="editable.children.terms[0].setData(null)">
                    <ul :class="clSub('stars', 'list-reset list-h')" slot-scope="{ setData, data }">
                        <li v-for="index in 5" :key="index">
                            <button @click="setData(index)" @mouseenter="ratingHover = index" @mouseleave="ratingHover = null">
                                <img :src="getIconSrc((data && data >= index) || (ratingHover && ratingHover >= index) ? 'star-full.svg' : 'star-empty.svg')" />
                            </button>
                        </li>
                    </ul>
                </editable-choose>

                <div :class="clSub('rating-keyword')">
                    <template v-if="ratingHover || editable.data.rating">
                        {{ __('rating_keywords.' + (ratingHover || editable.data.rating)) }}
                    </template>
                    <template v-else>&nbsp;</template>
                </div>

                <editable-choose name="terms" :class="clSub('terms-container')" :multiple="true">
                    <ul :class="clSub('terms', 'list-reset list-h justify-content-center')" v-if="editable.data.rating !== null" slot-scope="{ toggle, data }">
                        <li v-for="(term, index) in terms[editable.data.rating]" :key="index">
                            <button 
                                :class="{
                                    'btn btn-small': true,
                                    'btn-secondary': !data || !data.includes(index),
                                    'btn-primary': data && data.includes(index)
                                }"
                                @click="toggle(index)">

                                {{ term }}
                            </button>
                        </li>
                    </ul>
                </editable-choose>

                <editable-text v-if="allowMessage" 
                    name="text"
                    :class="clSub('message', 'mt-xll')"
                    :label="__('labels.message')"
                    :placeholder="__('placeholder.message.?')">
                </editable-text>
            </template>
        </editable>

        <div :class="clSub('buttons', 'buttons mt-xxl')" slot="footer">
            <button class="btn btn-secondary" @click="$refs.window.hide()">
                {{ __('#main.buttons.cancel') }}
            </button>
            <button class="btn btn-primary" @click="$refs.window.hide(getResult())" :disabled="!(rating && !isNaN(parseInt(rating.rating)))">
                {{ __('#main.buttons.send') }}
            </button>
        </div>
    </window>
</template>

<script>
import NeedsSetableCssClasses from '../Mixins/NeedsSetableCssClasses';
import NeedsIcons from '../Mixins/NeedsIcons';
import NeedsTranslations from '../Mixins/NeedsTranslations';

export default {
    mixins: [ NeedsSetableCssClasses, NeedsIcons, NeedsTranslations ],
    provide() {
        return {
            windowId: 'JobRating'
        };
    },
    props: {
        baseClass: {
            type: String,
            default: 'job-rating'
        },
        type: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: 'md'
        },
        terms: {
            type: Object,
            required: true
        },
        userPicture: {
            type: String
        },
        allowMessage: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        title() {
            return this.__('title');
        },
        translationKeyReplacements() {
            return [ this.type ];
        }
    },
    data() {
        return {
            rating: null,
            ratingHover: null,
            termsSelected: []
        };
    },
    methods: {
        typeTrans(key) {
            return this.__('jobs.windows.rating.' + key.replace('?', this.type));
        },
        getResult() {
            const data = this.rating;
            const terms = [];

            if(data.terms) {
                for(const termIndex of data.terms) {
                    terms.push(this.terms[data.rating][termIndex]);
                }
            }

            data.terms = terms;

            return data;
        }
    }
}
</script>